<style>
    .form-control[readonly]{
        background-color: rgba(0, 0, 0, .1);
        cursor: pointer;
    }
</style>
<template>
	<div class="panel panel-default m0 print-display">
		<div class="panel-heading">
			<div class="mb10 tie-4" v-if="withbtn != 'no'">
				<div class="tie-f mt5"><span class="cae bk bk-yellow">{{title}}</span></div>
				<div class="tie-s">
					<div class="bt-group pl15">
						<button class="btn btn-sm" v-for="el in btns" @click="changeColor(el)" :class="{'btn-primary': el.flag == flag,'btn-line': el.flag != flag}">{{el.name}}</button>
						<slot name="other"></slot>						
					</div>
				</div>
			</div>
			<div class="tie-4" v-if="withtime != 'no'">
				<div class="tie-f mt5"><span class="cae bk bk-blue">{{ctitle}}</span></div>
				<div class="tie-s time-group" >
                    <div class="row">
                    	<div class="col-sm-4 w200">
                        	<input type="text" class="form-control time_start" placeholder="开始时间"  v-model="data.date_start" readonly="">	
                    	</div>
                    	<div class="col-sm-1 w40 -ml25 mt3">
                    		<span class="input-group-addon form-control ">至</span>
                        </div>
                        <div class="col-sm-4 w200">
                        	<input type="text" class="form-control time_end" placeholder="结束时间" v-model="data.date_end"  readonly="">
                        </div>
                    </div>
                </div>
                <div class="tc mt20" v-if=" btn == 'yes'">
					<div class="form-hr"></div>
                	<button class="btn btn-sm btn-primary plr20 mt20" @click="search">搜索</button>
                	<slot name="show"></slot>
                </div>				
			</div>
		</div>
	</div>
</template>
<script>
	/**
	 * @author wxf
	 */

	var Http = require('../utils/HttpHelper.js');
	var data = {
		date_start: '',
		date_end: ''
	};
	var btnArr = [
		{
			'flag': '',
			'name': '全部'
		}, 
		{
			'flag':1,
			'name': '今天'

		},
		{
			'flag':2,
			'name': '昨天'
		},
		{
			'flag':7,
			'name': '最近7天'
		},
		{
			'flag':30,
			'name': '最近1月'
		}
	];
	//月份格式转换
	var formatTen = function(num) {
		return num > 9 ? (num + "") : ("0" + num); 
	};
	//标准日期格式转换
	var getLocalTime = function(s){
		s = new Date(s);
		var year = s.getFullYear();
		var month = s.getMonth() + 1;
		var day = s.getDate();
		var hour = s.getHours();
		var minute = s.getMinutes();
		var second = s.getSeconds();
		return year + "-" +  formatTen(month) + "-" + formatTen(day);
	};
	/*
	 *比较时间大小
	 */
	var compDate = function(date_one,date_two) {
		var one = Date.parse(date_one);//将日期格式转换成时间戳进行比较
		var two = Date.parse(date_two);
		var bool = one == two;
		return bool;
	};
	/**
	 * 获取当月天数,date为选择日期 2015-10-20 2016-11-01
	 */
	var getFormatTime = function(date) {
		var tmpyear = date.substr(0,4);//获取年
    	var tmpmonth = date.substr(5,2);//获取月
    	var tmpdays = date.substr(8,2);
    	var tmptime = new Date(tmpyear,tmpmonth,0);
    	var dayscount = tmptime.getDate();//获取月份天数
    	if(parseInt(tmpdays) + 1 > dayscount) {//加一天后 要进月、进年的情况
    		if(parseInt(tmpmonth) + 1 > 12) {
    			tmpyear = parseInt(tmpyear) + 1;
    			tmpmonth = 1;
    		} else {
    			tmpmonth = parseInt(tmpmonth) + 1;
    		}
    		tmpdays = 1;
    	} else {
    		tmpdays = parseInt(tmpdays) + 1;
    	}
    	var finalTime = tmpyear + "-" + formatTen(parseInt(tmpmonth)) + "-" + formatTen(tmpdays);
    	return finalTime;
	};
	/**
	* 组件对象
	*/
	// var change = function() {
	// 	var element = document.getElementsByClassName("time_start"); 
	// 	element.addEventListener("input",webChange); 

	// 	var webChange = function() {
	// 		if(element.value) {
	// 			alert(element.value);
	// 		} 
	// 	}
	// };
	/**
	 * 外部传入参数
	 * withtime 是否需要时间范围 no 不需要
	 * ctitle 时间指定标题
	 * withtime 是否需要时间按钮
	 * datetime 传过来的默认时间
	 */
	var Component = {
		props: ['title','withtime','btn','ctitle','withbtn', 'datetime'],
		data : function () {
			return {
				btns: btnArr,//按钮文字显示
				data: data,
				flag: '',//指定时间段
				nowDateTime: '',//当前时间
				today_start: '',//今天开始时间
				today_end: '',//今天23:59:59
				yesterday_start: '',//昨天开始时间
				yesterday_end: '',//昨天结束时间
				lastmonth_start: '',//最近1月开始时间
				lastweek_start: '',//最近7天开始时间,
				markStart: "",//标识时间范围与时间段是否对应 (控制按钮显示)
				markEnd: "",//同上
				date_end: ''//结束时间+1
			}
		},
		ready: function() {
			if(this.ctitle == undefined) {
				this.ctitle = "指定范围";
			}
			var self = this;
			var time = new Date();
			var year = time.getFullYear();
			var month = time.getMonth() + 1;
			var day = time.getDate();
        	var oneDay = 24*60*60*1000//1天时间戳 24：00：00
        	var todayT =  Date.parse(year + "-" + month + "-" + day);	  //今天开始时间 
        	var today_endT = todayT;//今天结束时间
        	var yesterdayT = todayT - oneDay;//昨天开始时间
        	var yesterday_endT = todayT;//昨天结束时间 = 今天开始时间
        	var lastweekT = todayT - 6*oneDay;//最近7天开始时间
        	this.today_start = getLocalTime(todayT);//今日开始时间
        	this.nowDateTime = getLocalTime(today_endT);//现在时间
        	this.today_end = getLocalTime(today_endT);//当天23:59:59
        	this.yesterday_start = getLocalTime(yesterdayT);//昨天开始时间
        	this.yesterday_end = this.today_start;//昨天结束时间
        	this.lastweek_start =  getLocalTime(lastweekT);//最近7天开始时间
        	if(month - 1 <= 0) {//如果月数不够减，将年数减1 再对月份进行处理
        		month = 12 - (month - 1);
        		year = year - 1;
        	} else {
        		month = month - 1;
        	}
        	this.lastmonth_start = year + "-" + formatTen(month) + "-" + formatTen(day);//最近1月开始时间
			this.data = {
				date_start: '',
				date_end: ''
			}
			$('.time_start').datetimepicker({
	            format: 'yyyy-mm-dd',
	            language:'zh-CN', 
	            autoclose: 1,
	            minView:2,
	            todayBtn: 'linked',
	        });
	        $(".time_end").datetimepicker({
	            format: 'yyyy-mm-dd',
	            language:'zh-CN',
	            autoclose: 1,
	            minView:2,
	            todayBtn: 'linked',
	        });

	        if(this.datetime){
		        $('.time_start').val(this.today_start);
		        $('.time_end').val(this.today_end);
        		this.data.date_start = this.datetime.date_start;
        		this.date_end = this.datetime.date_end;
        	}
        	

	        //监控按钮选择。日期数据联动	        
	        this.$watch('flag',function(e){
	        	if(e == '') {
	        		self.data.date_start = '';
					self.data.date_end = '';
					self.date_end = '';
	        	} else {
	        		if(e == 1) {
		        		self.data.date_end = self.nowDateTime;
		        		self.data.date_start = 	self.today_start;
		        	} else if(e == 2) {
		        		self.data.date_start = self.yesterday_start;
		        		self.data.date_end = self.yesterday_start;
		        	} else if(e ==7) {
		        		self.data.date_start = self.lastweek_start;
		        		self.data.date_end = self.nowDateTime;
		        	} else if(e ==30) {
		        		self.data.date_start = self.lastmonth_start;
		        		self.data.date_end = self.nowDateTime;
		        	}
		        	/*应后台及设计要求，界面上时间显示当天起止日期都是一个日期，传值时，结束时间为当天日期加1天*/
		        	self.date_end = getFormatTime(self.data.date_end);//调用加1天的方法
		        }
	        });
	        /*
	         * 指定范围反推指定时间
	         */
	        var dateStart = self.data.date_start;//开始日期
	        var dateEnd = self.data.date_end;//结束日期
	        this.$watch('data.date_start',function(e){
	        	if(self.data.date_end != "") {
	        		if(compDate(e,self.today_start) && compDate(self.data.date_end,self.today_end)) {
			       		self.flag = 1;
			       	} else if(compDate(e,self.yesterday_start) && compDate(self.data.date_end,self.yesterday_start)) {
			       		self.flag = 2;
			       	} else if(compDate(e,self.lastweek_start) && compDate(self.data.date_end,self.today_end)) {
			       		self.flag = 7;
			       	} else if(compDate(e,self.lastmonth_start) && compDate(self.data.date_end,self.today_end)) {
			       		self.flag = 30;
			       	} else {
			       		$('.time_start').value = e;
	       				$('.time_end').value = self.data.date_end;
	       				self.flag = 10;
			       	}
	        	}
	       	});
	       	//
	       	this.$watch('data.date_end',function(e){
	       		self.date_end = e;
	       		if(self.data.date_start != "") {
	       			if(compDate(self.data.date_start,self.today_start) && compDate(e,self.today_end)) {
			       		self.flag = 1;
			       	} else if(compDate(self.data.date_start,self.yesterday_start) && compDate(e,self.yesterday_start)) {
			       		self.flag = 2;
			       	} else if(compDate(self.data.date_start,self.lastweek_start) && compDate(e,self.today_end)) {
			       		self.flag = 7;
			       	} else if(compDate(self.data.date_start,self.lastmonth_start) && compDate(e,self.today_end)) {
			       		self.flag = 30;
			       	} else {
			       		self.flag = 10;
			       		self.data.date_end = e;
			       	}	
			       	/*应后台及设计要求，界面上时间显示当天起止日期都是一个日期，传值时，结束时间为当天日期加1天*/
		        	self.date_end = getFormatTime(self.data.date_end);//调用加1天的方法				       		
			    }
	       	});   
		},
		computed: {
			cond: function(){		
				var arr = [this.data.date_start, this.date_end, this.data.date_end];
				return arr;
			}
		},
		methods: {
			changeColor: function(el) {
				this.flag = el.flag;
			},
			search: function(){
				this.$dispatch('search');//分发传递
			}
		}
	};
	module.exports = Component;
</script>


/** WEBPACK FOOTER **
 ** Condition.vue?29903778
 **/